export const allQuestions = [
  {
    type: "multiple_choice",
    question: "How many articles are in the original U.S. Constitution?",
    options: ["5", "7", "10", "12"],
    correctIndex: 1,
    explanation: "The Constitution contains 7 articles that establish the framework of government.",
    citation: "U.S. Const. art. I–VII",
    citationUrl: "https://constitution.congress.gov/browse/"
  },
  {
    type: "multiple_choice",
    question: "Which article establishes the Legislative Branch?",
    options: ["Article I", "Article II", "Article III", "Article IV"],
    correctIndex: 0,
    explanation: "Article I establishes Congress and defines its powers.",
    citation: "U.S. Const. art. I",
    citationUrl: "https://constitution.congress.gov/browse/article-1/"
  },
  {
    type: "true_false",
    question: "Each state has two senators regardless of population.",
    options: ["True", "False"],
    correctIndex: 0,
    explanation: "The Constitution guarantees equal representation in the Senate with two senators per state.",
    citation: "U.S. Const. art. I, § 3, cl. 1",
    citationUrl: "https://constitution.congress.gov/browse/article-1/section-3/"
  },
  {
    type: "multiple_choice",
    question: "What is the minimum age requirement to be President?",
    options: ["30 years", "35 years", "40 years", "45 years"],
    correctIndex: 1,
    explanation: "Article II requires the President to be at least 35 years old.",
    citation: "U.S. Const. art. II, § 1, cl. 5",
    citationUrl: "https://constitution.congress.gov/browse/article-2/section-1/"
  },
  {
    type: "multiple_choice",
    question: "Which article establishes the Judicial Branch?",
    options: ["Article I", "Article II", "Article III", "Article IV"],
    correctIndex: 2,
    explanation: "Article III establishes the Supreme Court and federal judiciary.",
    citation: "U.S. Const. art. III",
    citationUrl: "https://constitution.congress.gov/browse/article-3/"
  },
  {
    type: "multiple_choice",
    question: "How many amendments are in the Bill of Rights?",
    options: ["5", "10", "15", "27"],
    correctIndex: 1,
    explanation: "The first 10 amendments comprise the Bill of Rights.",
    citation: "U.S. Const. amend. I–X",
    citationUrl: "https://constitution.congress.gov/browse/amendment-1/"
  },
  {
    type: "multiple_choice",
    question: "What fraction of Congress is needed to override a presidential veto?",
    options: ["Simple majority", "Three-fifths", "Two-thirds", "Three-fourths"],
    correctIndex: 2,
    explanation: "Article I requires a two-thirds vote in both houses to override a veto.",
    citation: "U.S. Const. art. I, § 7, cl. 2",
    citationUrl: "https://constitution.congress.gov/browse/article-1/section-7/"
  },
  {
    type: "true_false",
    question: "The President has the power to declare war.",
    options: ["True", "False"],
    correctIndex: 1,
    explanation: "Only Congress has the power to declare war, as stated in Article I.",
    citation: "U.S. Const. art. I, § 8, cl. 11",
    citationUrl: "https://constitution.congress.gov/browse/article-1/section-8/"
  },
  {
    type: "multiple_choice",
    question: "How long is a term for a U.S. Senator?",
    options: ["2 years", "4 years", "6 years", "8 years"],
    correctIndex: 2,
    explanation: "Senators serve six-year terms as specified in Article I.",
    citation: "U.S. Const. art. I, § 3, cl. 1",
    citationUrl: "https://constitution.congress.gov/browse/article-1/section-3/"
  },
  {
    type: "multiple_choice",
    question: "What is required to amend the Constitution?",
    options: ["Majority vote in Congress", "Two-thirds of both houses and three-fourths of states", "Presidential approval", "Supreme Court ruling"],
    correctIndex: 1,
    explanation: "Article V requires proposal by 2/3 of Congress and ratification by 3/4 of states.",
    citation: "U.S. Const. art. V",
    citationUrl: "https://constitution.congress.gov/browse/article-5/"
  }
];

export const topics = [
  'All Topics',
  'Bill of Rights (Amendments 1-10)',
  'Articles (I, II, III - Three Branches)',
  'Amendments (11-27)',
  'Federalism & States',
  'Rights & Freedoms',
  'Checks & Balances'
];
